import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
// import NumberFormat from "react-number-format";
import Select from "react-select";
import tooltipText from "../../../ShortCutComponents/tooltipText";
// import SelectorCountry from "./views/Forms/ShortCutComponents/selector_country";

import "./../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { AppSwitch } from "@coreui/react";
import { baseurl } from "../../../../../baseurl";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { GetIp } from "../../../ShortCutComponents/Get_ip";
import ReactDatePicker from "../../../ShortCutComponents/ReactDatePicker";
import ResponseLoader from "../../../ShortCutComponents/ResponseLoader";

const username = localStorage.getItem("username");
const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");

export default function KitcenItemForm(props) {
  console.log("props from ahmad", props);
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [getDataUom, setGetDataUom] = useState([]);

  const [recipeQty, setRecipeQty] = useState(1);
  // const [date, setDate] = useState();
  // const [productionNumber, setProductionNumber] = useState();
  // const [remarks, setRemarks] = useState();

  const [getDataPartyType, setGetDataPartyType] = useState([]);
  const [desigLov, setDesigLov] = useState([]);
  const [checkPartyType, setCheckPartyType] = useState(false);
  const [checkCountry, setCheckCountry] = useState(false);
  const [divcontainer, setDivcontainer] = useState(true);

  const [masterData, setMasterData] = useState({
    dealNo: null,
    dealDate: "",
    targetDate: "",
    companyName: "",
    dealDescription: "",
    societyId: "",
    sectorId: "",
    midManId: "",
    remarks: "",
  });

  const [data, setData] = useState({
    formValues: [
      {
        lineNum: 1,
        unitNo: "",
        type: "",
        category: null,
        size: "",
        companyPrize: 0,
        commission: 0,
        totalCost: null,
      },
    ],
  });
  const [partnership, setPartnership] = useState({
    partner: "",
    percentage: null,
    pRemarks: "",
  });

  const removeFormFieldsItem = (i) => {
    let formValues = data.formValues;

    if (formValues.length > 1) {
      let totalqty = 0;
      let totalamount = 0;
      let totaldiscount = 0;
      let totalnet = 0;
      let totalTireDisposal = 0;
      let totslAmountIncAll = 0;
      let labour = data.labour;
      let tireDisposalLov = data.tireDisposalLov;
      let totalTireFee = 0;
      let sumSaleTaxVal = 0;

      formValues.splice(i, 1);

      for (let index = 0; index < formValues.length; index++) {
        totalqty = parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
        totalamount =
          parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
        totaldiscount =
          parseFloat(totaldiscount) + parseFloat(formValues[index]["discount"]);
        totalnet =
          parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);

        totalTireDisposal += +formValues[index]["tireDisposal"];

        sumSaleTaxVal += +formValues[index]["fetTaxAmount"];

        if (formValues[index]["isChecked"] == true) {
          totalTireFee += +parseFloat(1.75 * formValues[index]["qty"]);
        }
        totslAmountIncAll =
          parseFloat(totalnet ? totalnet : 0) +
          parseFloat(totalTireDisposal ? totalTireDisposal : 0) +
          parseFloat(totalTireFee ? totalTireFee : 0) +
          parseFloat(labour ? labour : 0);
        formValues[index]["lineNum"] = index + 1;
      }
      setData({
        ...data,
        formValues,
        totalqty,
        totalamount,
        totaldiscount,
        totalnet,
        totalTireDisposal,
        totalTireFee,
        totslAmountIncAll,
        sumSaleTaxVal: sumSaleTaxVal,
      });
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  };
  const addFormFieldsItem = () => {
    let lineNumber = data.formValues.length + 1;
    console.log(getDataPartyType);
    console.log(getDataUom);
    setData({
      formValues: [
        ...data.formValues,
        {
          // itemLov: getDataPartyType.partyTypeOptions,
          // itemCodeLov: getDataUom,
          lineNum: lineNumber,
          // itemCode: null,
          // recipeQty: recipeQty,
        },
      ],
      show: false,
    });
  };
  // const selectUOMEvent = (uomField, index) => {
  //   console.log("item list----------------", uomField);
  //   console.log("----------------", uomField?.id);
  //   console.log("----------------", uomField?.uomDesc);
  //   let formValues = data.formValues;

  //   formValues[index]["uom"] = uomField;
  //   setData({
  //     ...data,
  //     formValues,
  //   });

  //   if (uomField?.id) {
  //     let itemId = uomField?.id;
  //     let itemTypeId = uomField?.itemTypeId;
  //     itemTypeLov(itemTypeId, index);
  //     axios
  //       .post(
  //         `${baseurl}/pointOfSale/getRecipeCostById`,
  //         { id: itemId, companyId: companyId, username: username },
  //         {
  //           headers: {
  //             authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         let resData = res.data.data;

  //         console.log("resData :>> ", resData);
  //         // saif
  //         let calc_cost = resData[0]?.["calc_cost"];
  //         console.log(calc_cost);
  //         let recipeAmount = calc_cost * recipeQty;
  //         console.log(recipeAmount);

  //         let formValues = data.formValues;
  //         formValues[index]["itemCode"] = uomField;
  //         formValues[index]["itemTypeId"] = uomField?.id;
  //         formValues[index]["itemDescription"] = uomField?.ItemDescription;
  //         formValues[index]["uomName"] = uomField?.uomDesc;
  //         formValues[index]["recipeCost"] = calc_cost;
  //         formValues[index]["recipeAmount"] = recipeAmount;
  //         setData({
  //           ...data,
  //           formValues,
  //         });
  //         console.log("-===-=-=-=-=-=", data.formValues);

  //         // setRecipeCost(calc_cost);
  //         // setRecipeAmount(calc_cost * recipeQty);

  //         let amount = calc_cost * recipeQty;
  //         console.log("-==-=-----------------------", typeof amount, amount);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   } else {
  //     let formValues = data.formValues;
  //     formValues[index]["itemType"] = null;
  //     formValues[index]["itemDescription"] = "";
  //     formValues[index]["uomName"] = "";
  //     formValues[index]["uom"] = "";
  //     formValues[index]["recipeCost"] = "";
  //     formValues[index]["recipeQty"] = 1;
  //     formValues[index]["recipeAmount"] = "";
  //     console.log(formValues);
  //     setData({
  //       ...data,
  //       formValues,
  //     });
  //     itemTypeLov("", index);
  //     itemCodeLov("", index);
  //   }
  //   console.log(data.formValues);
  // };
  // const selectItemTypeEvent = (itemTypeField, index) => {
  //   console.log("itemmm----------------", itemTypeField);
  //   let itemTypeId = itemTypeField?.id;
  //   let formValues = data.formValues;

  //   formValues[index]["itemType"] = itemTypeField;
  //   setData({
  //     ...data,
  //     formValues,
  //   });

  //   itemCodeLov(itemTypeId, index);
  // };

  // const itemCodeLov = (itemTypeId, index) => {
  //   axios
  //     .post(
  //       `${baseurl}/lovs/getItem`,

  //       { companyId: companyId, username: username },
  //       {
  //         headers: {
  //           authorization: token,
  //         },
  //       }
  //     )
  //     .then(function (response) {
  //       let mydata = [];
  //       let responseData = response.data.data;
  //       console.log("=====================", responseData);
  //       console.log("=====================", responseData[0]?.ITEM_TYPE_ID);
  //       if (itemTypeId) {
  //         for (let loop = 0; loop < responseData.length; loop++) {
  //           if (itemTypeId == responseData[loop]?.ITEM_TYPE_ID) {
  //             mydata.push({
  //               id: responseData[loop]["ITEM_ID"],
  //               label: responseData[loop]["ITEM_CODE"],
  //               itemCode: responseData[loop]["ITEM_CODE"],
  //               ItemDescription: responseData[loop]["ITEM_DESC"],
  //               uomDesc: responseData[loop]["UOM_DESC"],
  //               uomId: responseData[loop]["UOM_ID"],
  //             });
  //           }
  //         }
  //       } else {
  //         for (let loop = 0; loop < responseData.length; loop++) {
  //           mydata.push({
  //             id: responseData[loop]["ITEM_ID"],
  //             label: responseData[loop]["ITEM_CODE"],
  //             itemCode: responseData[loop]["ITEM_CODE"],
  //             ItemDescription: responseData[loop]["ITEM_DESC"],
  //             uomDesc: responseData[loop]["UOM_DESC"],
  //             uomId: responseData[loop]["UOM_ID"],
  //             itemTypeId: responseData[loop]["ITEM_TYPE_ID"],
  //           });
  //         }
  //         setGetDataUom(mydata);
  //       }
  //       let formValues = data.formValues;
  //       formValues[index]["itemCodeLov"] = mydata;
  //       console.log(mydata);
  //       setData(...data, formValues);
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //     });
  // };
  // const itemTypeLov = (itemId, index) => {
  //   let itemTypedata = [];

  //   axios
  //     .post(
  //       `${baseurl}/lovs/getItemType`, //query se hm item Id k against is lye handle nhi kr rhy qk hoskta h ye query kahi or b use horhi ho
  //       { companyId: companyId, username: username },
  //       {
  //         headers: {
  //           authorization: token,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       let responseData = response.data.data;
  //       console.log("===-=-=-=-=-=-=-=-=-", responseData[1]?.itemId);

  //       if (!itemId) {
  //         for (let loop = 0; loop < responseData.length; loop++) {
  //           itemTypedata.push({
  //             id: responseData[loop]?.ITEM_TYPE_ID,
  //             label: `${responseData[loop]?.ITEM_TYPE_DESC}`,
  //             itemId: responseData[loop]?.itemId,
  //           });
  //         }
  //         setGetDataPartyType({
  //           ...getDataPartyType,
  //           partyTypeOptions: itemTypedata,
  //         });
  //       } else {
  //         for (let loop = 0; loop < responseData.length; loop++) {
  //           if (itemId == responseData[loop]?.ITEM_TYPE_ID) {
  //             itemTypedata.push({
  //               id: responseData[loop]?.ITEM_TYPE_ID,
  //               label: `${responseData[loop]?.ITEM_TYPE_DESC}`,
  //               itemId: responseData[loop]?.itemId,
  //             });
  //             let itemType = itemTypedata[0];
  //           }
  //           setData({
  //             ...data,
  //             itemType: itemId ? itemTypedata[0] : "",
  //           });
  //         }
  //       }
  //       let formValues = data.formValues;
  //       formValues[index]["itemLov"] = [...itemTypedata];
  //       if (itemId) {
  //         formValues[index]["itemType"] = [...itemTypedata];
  //       }
  //       setData({
  //         ...data,
  //         formValues,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const masterInputEvent = (e, pName) => {
    if (pName === "companyName") {
      setMasterData({ ...masterData, companyName: e });
      setCheckPartyType(false);
      console.log("===========================", e);
    } else if (pName === "societyId") {
      setMasterData({ ...masterData, societyId: e });
      setCheckCountry(false);
      console.log("===========================", e);
    } else if (pName === "sectorId") {
      setMasterData({ ...masterData, sectorId: e });
      setCheckCountry(false);
      console.log("===========================", e);
    } else if (pName === "midManId") {
      setMasterData({ ...masterData, midManId: e });
      setCheckCountry(false);
      console.log("===========================", e);
    } else if (pName === "partner") {
      setPartnership({ ...partnership, partner: e });
      setCheckCountry(false);
      console.log("===========================", e);
    } else if (pName === "partnership") {
      console.log(e.target.value);
      const value = e.target.value;
      const name = e.target.name;

      console.log("===========================", name, value);
      setPartnership({ ...partnership, [name]: value });
    } else {
      console.log(e.target.value);
      const value = e.target.value;
      const name = e.target.name;

      console.log("===========================", name, value);
      setMasterData({ ...masterData, [name]: value });
    }
  };
  const inputEvent = (e, index, pName) => {
    let formValues = data.formValues;

    if (pName) {
      if (pName === "type") {
        formValues[index]["type"] = e;
        console.log("===========================", e);
      } else if (pName === "size") {
        formValues[index]["size"] = e;
        console.log("===========================", e);
      }
    } else {
      console.log(e.target.value);

      const value = e.target.value;
      const name = e.target.name;
      let companyPrize = formValues[index]["companyPrize"];
      let commission = formValues[index]["commission"];
      let amount1 = parseInt(value) + parseInt(commission);
      let amount2 = parseInt(value) + parseInt(companyPrize);

      console.log("===========================", name, value, typeof value);

      if (name === "unitNo") {
        formValues[index]["unitNo"] = value;
      } else if (name === "category") {
        formValues[index]["category"] = value;
      } else if (name === "companyPrize") {
        formValues[index]["companyPrize"] = value;
        formValues[index]["totalCost"] = amount1;
      } else if (name === "commission") {
        formValues[index]["commission"] = value;
        formValues[index]["totalCost"] = amount2;
      } else if (name === "totalCost") {
        formValues[index]["totalCost"] = value;
      }
    }
    setData({
      ...data,
      formValues,
    });
  };
  const partyTypeLov = () => {
    let partyTypedata = [];

    axios
      .post(
        `${baseurl}/realEState/getPartyType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          partyTypedata.push({
            id: responseData[loop]?.Party_type_id,
            label: `${responseData[loop]?.Party_type_desc}`,
          });
        }
        setGetDataPartyType({
          ...getDataPartyType,
          partyTypeOptions: partyTypedata,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getDesigData = () => {
    axios
      .post(
        `${baseurl}/Support/getSuppDesig`,
        {
          companyId: companyId,
          username: username,
          // brId: this.props?.location.state?.row_branch_id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let pushDataArray = [];
        let getItemData = res.data.data;
        console.log("jjjjjjjjjjjjjjj", getItemData);
        let statusValue;
        for (let i = 0; i < getItemData.length; i++) {
          let desigDesc = getItemData[i]["desig_desc"];
          let desigObj = getItemData[i]["desig_id"];

          pushDataArray.push({
            id: desigObj,
            label: desigDesc,
          });
        }
        console.log("pushDataArray :>> ", pushDataArray);
        //Storing users detail in state array object
        setDesigLov({
          ...desigLov,
          desigOptions: pushDataArray,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChangeMapHideShow = (e) => {
    setDivcontainer(!divcontainer);
    console.log("======================", divcontainer);
  };

  useEffect(() => {
    console.log("-------------------------", props.location?.state?.rowData.id);
    console.log("-----------===--------------", masterData);
    let id = props.location?.state?.rowData.id;
    getDesigData();

    // itemTypeLov("", 0);
    partyTypeLov();
  }, []);
  // const getData = (id) => {
  //   axios
  //     .post(
  //       `${baseurl}/pointOfSale/getproductionReceipeById`,
  //       {
  //         id: id,
  //         companyId: companyId,
  //         username: username,
  //       },
  //       {
  //         headers: {
  //           authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("---------------", res.data.data);
  //       let getRecipeCost = res.data.data;
  //       let dateArray = [];
  //       console.log("jjjjjjjjjjjjjjjjjjjjj", getRecipeCost);
  //       console.log("hhhhhhhh", getRecipeCost[0]["prod_no"]);
  //       let productionNumber = getRecipeCost[0]["prod_no"];
  //       let remarks = getRecipeCost[0]["master_remarks"];
  //       let date = new Date(getRecipeCost[0]["Date"]);
  //       // let date =  moment(getRecipeCost[0]["Date"]).format(
  //       //   "DD-MMM-YYYY");
  //       // console.log(productionNumber, remarks, date);

  //       // setDate(date);
  //       // setProductionNumber(productionNumber);
  //       // setRemarks(remarks);
  //       console.log("llllllllllll", data.formValues);

  //       let formValues = [];
  //       let element;
  //       let uom;
  //       let itemType;

  //       for (let i = 0; i < getRecipeCost.length; i++) {
  //         element = getRecipeCost[i];
  //         console.log(element);
  //         uom = {
  //           id: element["ITEM_ID"],
  //           label: element["ITEM_CODE"],
  //         };
  //         itemType = {
  //           id: element["ITEM_TYPE_ID"],
  //           label: element["ITEM_TYPE_DESC"],
  //         };
  //         let itemDescription = element["ITEM_DESC"];
  //         let uomName = element["UOM_DESC"];
  //         let recipeQty = element["qty"];
  //         let recipeCost = element["cost"]; // cost is coming from db in api
  //         let recipeAmount = element["amount"];
  //         let remarks = element["lineRemarks"];

  //         formValues.push({
  //           uom,
  //           itemType,
  //           itemDescription,
  //           uomName,
  //           recipeQty,
  //           recipeCost,
  //           recipeAmount,
  //           remarks,
  //         });
  //       }
  //       console.log(formValues);
  //       setData({
  //         ...data,
  //         formValues,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const handleSubmit = async (event) => {
    console.log("agiiiiiiaaaaaaaaa", masterData, data);
    event.preventDefault();
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    console.log(companyId);
    let { userIp, userCountry } = await getUserIp();
    let partyTypeId = masterData?.partyId?.id;
    let countryName = masterData?.country?.label;
    console.log("=====aaaaaaaaa", partyTypeId, countryName);
    if (partyTypeId && countryName) {
      if (props.EditData > -1) {
        let Id = props.EditData;
        axios
          .post(
            `${baseurl}/issueType/getUpdateIssueType`,
            {
              Id,

              companyId,
              issueType: data.issueType,
              ridAddress: data.ridAddress,
              username: username,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            setLoadingResponce(false);
            console.log(response.data);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "Issue Type Updated!",
                icon: "success",
              }).then((value) => {
                // toggleAddNew();
                // thisContex.setState({
                //   tableData:[],
                // })
                // thisContex.updateModalToggle();
                // thisContex.getData();
              });
            }
            // return;
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        console.log(window.location.pathname);

        console.log(data.formValues);
        axios
          .post(
            `${baseurl}/realEState/addParty`,
            {
              companyId,
              partyTypeId: partyTypeId,
              partyCode: masterData.partyCode,
              partyName: masterData.partyName,
              addressLine1: masterData.addressLine1,
              addressLine2: masterData.addressLine2,
              city: masterData.city,
              country: countryName,
              cellNo: masterData.cellNo,
              email: masterData.email,
              url: masterData.url,
              remarks: masterData.remarks,

              detailArray: data.formValues,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Production Recipe Added",
                icon: "success",
              }).then((value) => {
                // toggleAddNew();
                props.history.push({
                  pathname: "/PartyOverview",
                });
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);
      if (!partyTypeId) setCheckPartyType(true);
      if (!countryName) setCheckCountry(true);
    }
  };
  return (
    <>
      {loadingResponce === true ? (
        <ResponseLoader />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="6" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>Deal Setup Form</h4>
                </strong>
              </>
            </Col>
            <Col xs="6" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  // to="/PartyOverview"
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>

          <Row className="rowStyling">
            <Col>
              <div className="row">
                <div className="col-md-12">
                  <Form name="simpleForm" onSubmit={handleSubmit}>
                    <div className="row">
                      {/* <div className="col-md-12">
                          <div className="row my-2" translate="no"></div>
                        </div> */}
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Deal No:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="dealNo"
                          id="dealNo"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.dealNo}
                          required
                        />
                      </div>
                      <ReactDatePicker
                        label="Deal Date:"
                        className="col-xl-3"
                        isSelected={masterData.dealDate}
                        onChange={(e) => {
                          setMasterData({ ...masterData, dealDate: e });
                        }}
                      />
                      <ReactDatePicker
                        label="Target Date:"
                        className="col-xl-3"
                        isSelected={masterData.targetDate}
                        onChange={(e) => {
                          setMasterData({ ...masterData, targetDate: e });
                        }}
                      />
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Company Name:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={getDataPartyType.partyTypeOptions}
                          onChange={(e) => masterInputEvent(e, "companyName")}
                          value={masterData.companyName}
                          required
                          id="companyName"
                          name="companyName"
                          isClearable
                          placeholder={"-- Select --"}
                        />

                        {checkPartyType ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Party Type</p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Deal Description:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="dealDescription"
                          id="dealDescription"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.dealDescription}
                          required
                        />
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Society:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={getDataPartyType.partyTypeOptions}
                          onChange={(e) => masterInputEvent(e, "societyId")}
                          value={masterData.societyId}
                          required
                          id="societyId"
                          name="societyId"
                          isClearable
                          placeholder={"-- Select --"}
                        />

                        {checkPartyType ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Party Type</p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Sector/Phase:
                          <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={getDataPartyType.partyTypeOptions}
                          onChange={(e) => masterInputEvent(e, "sectorId")}
                          value={masterData.sectorId}
                          required
                          id="sectorId"
                          name="sectorId"
                          isClearable
                          placeholder={"-- Select --"}
                        />

                        {checkPartyType ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Party Type</p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Middle Man:
                          {/* <span style={{ color: "tomato" }}>*</span> */}
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={getDataPartyType.partyTypeOptions}
                          onChange={(e) => masterInputEvent(e, "midManId")}
                          value={masterData.midManId}
                          required
                          id="midManId"
                          name="midManId"
                          isClearable
                          placeholder={"-- Select --"}
                        />
                      </div>
                      <div
                        className="col-md-6"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>Remarks:</Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="remarks"
                          id="remarks"
                          onChange={(e) => masterInputEvent(e)}
                          value={masterData.remarks}
                        />
                      </div>

                      <div className="col-md-12 lableDivStyling">
                        <Row className="pt-1">
                          <Col xs="6">
                            <>
                              <span style={{ fontWeight: "bold" }}>
                                Total Properties
                              </span>
                            </>
                          </Col>
                          <Col xs="6">
                            <div
                              style={{
                                textAlign: "right",
                              }}
                            >
                              <AppSwitch
                                className={"mx-1"}
                                onClick={handleChangeMapHideShow}
                                variant="pill"
                                color="primary"
                                label
                                checked={divcontainer}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                      {divcontainer ? (
                        <div className="col-md-12 mb-2">
                          {data.formValues.map((element, index) => (
                            <div className="div my-1">
                              <div className="InvoiceLine-styling ">
                                {/* <div className="col-md-4 col-lg-4 col-xl-3  InvoiceLineHeading">
                                  <h6>
                                    Contact Person Details # {element.lineNum}{" "}
                                  </h6>
                                </div> */}
                                <div class="row">
                                  <div className="col-md-3  ">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Unit No:
                                      <h8 style={{ color: "tomato" }}>*</h8>
                                    </Label>

                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="unitNo"
                                      id="unitNo"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.unitNo}
                                      required
                                    />
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Type:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Select
                                      // key={JSON.stringify(element.itemType)}
                                      value={element.type}
                                      onChange={(e) =>
                                        inputEvent(e, index, "type")
                                      }
                                      options={desigLov.desigOptions}
                                      id="type"
                                      name="type"
                                      isClearable
                                      placeholder={"-- Select --"}
                                    />

                                    {/* {errorItemCatChild ? (
                                    <div style={{ color: "red" }}>
                                      <p>Please Select Item Type</p>
                                    </div>
                                  ) : null} */}
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Category:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Input
                                      type="number"
                                      className="form-control"
                                      name="category"
                                      id="category"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.category}
                                    />
                                  </div>
                                  <div
                                    className="col-md-3"
                                    style={{ marginBottom: "12px" }}
                                  >
                                    <Label style={{ fontWeight: "bold" }}>
                                      Size:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Select
                                      // key={JSON.stringify(element.itemType)}
                                      value={element.size}
                                      onChange={(e) =>
                                        inputEvent(e, index, "size")
                                      }
                                      options={desigLov.desigOptions}
                                      id="size"
                                      name="size"
                                      isClearable
                                      placeholder={"-- Select --"}
                                    />

                                    {/* {errorItemCatChild ? (
                                    <div style={{ color: "red" }}>
                                      <p>Please Select Item Type</p>
                                    </div>
                                  ) : null} */}
                                  </div>
                                  <div className="col-md-3  ">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Company Price:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Input
                                      type="number"
                                      className="form-control"
                                      name="companyPrize"
                                      id="companyPrize"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.companyPrize}
                                    />
                                  </div>
                                  <div className="col-md-3  ">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Commission:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Input
                                      type="number"
                                      className="form-control"
                                      name="commission"
                                      id="commission"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.commission}
                                    />
                                  </div>
                                  <div className="col-md-3  ">
                                    <Label style={{ fontWeight: "bold" }}>
                                      Total Cost:
                                      <span style={{ color: "tomato" }}>*</span>
                                    </Label>

                                    <Input
                                      type="number"
                                      className="form-control"
                                      name="totalCost"
                                      id="totalCost"
                                      onChange={(e) => inputEvent(e, index)}
                                      value={element.totalCost}
                                      disabled
                                    />
                                  </div>
                                  <div className="col-md-2 pt-4 mt-1">
                                    <div>
                                      <Button
                                        className="btn btn-info text-white mx-2"
                                        type="button"
                                        size="sm"
                                        onClick={() => addFormFieldsItem()}
                                        // title={tooltipText.addMulLineInv}
                                        // disabled={
                                        //   this.state.disabled ? true : false
                                        // }
                                      >
                                        <i className="fa fa-plus "></i>
                                      </Button>

                                      <Button
                                        type="button"
                                        size="sm"
                                        className="btn btn-danger "
                                        onClick={() =>
                                          removeFormFieldsItem(index)
                                        }
                                        title={tooltipText.remMulLineInv}
                                        // disabled={disabled ? true : false }
                                      >
                                        <i className="fa fa-trash "></i>
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                      <div
                        className="col-md-12 mt-2 lableDivStyling"
                        // style={{ top: "6px" }}
                      >
                        <div
                          className="col-md-3"
                          style={{ marginLeft: "-14px", top: "6px" }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            Partnership
                          </span>
                        </div>
                      </div>
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Partner:
                          {/* <span style={{ color: "tomato" }}>*</span> */}
                        </Label>

                        <Select
                          // key={JSON.stringify(element.itemType)}
                          // value={element.itemType}
                          // onChange={(e) => selectItemTypeEvent(e, index)}
                          options={getDataPartyType.partyTypeOptions}
                          onChange={(e) => masterInputEvent(e, "partner")}
                          value={partnership.partner}
                          // required
                          id="partner"
                          name="partner"
                          isClearable
                          placeholder={"-- Select --"}
                        />

                        {checkPartyType ? (
                          <div style={{ color: "red" }}>
                            <p>Please Select Party Type</p>
                          </div>
                        ) : null}
                      </div>
                      <div
                        className="col-md-2"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Percentage %:
                          {/* <span style={{ color: "tomato" }}>*</span> */}
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="percentage"
                          id="percentage"
                          onChange={(e) => masterInputEvent(e, "partnership")}
                          value={partnership.percentage}
                          // required
                        />
                      </div>
                      <div
                        className="col-md-7"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>Remarks:</Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="pRemarks"
                          id="pRemarks"
                          onChange={(e) => masterInputEvent(e, "partnership")}
                          value={partnership.pRemarks}
                        />
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup>
                      <Button className="mr-1 invoiceSubmitButton ">
                        {props.EditData > -1 ? "Update" : "Save"} Changes
                      </Button>
                      <Button className="mr-1" size="sm">
                        Cancel
                      </Button>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
